import { AnyAction } from 'redux';
import { iDevicePing } from '../../../shared/interfaces';
import {
    CLEAR_REPLAY_POINT,
    ReplaySpeed,
    SET_ACTIVE_DEVICE_ID,
    SET_ACTIVE_TRIP_ID,
    SET_REPLAY_PLAYING,
    SET_REPLAY_POINT,
    SET_REPLAY_SPEED
} from './AC';

export interface IReplayPointState {
    point: iDevicePing | null;
    activeDeviceId: string | null;
    activeTripId: string | null;
    speed: ReplaySpeed; // Replay speed multiplier (0.5, 1, 1.5, 2)
    isPlaying: { [deviceId: string]: boolean }; // Track playing state per device
}

const initialState: IReplayPointState = {
    point: null,
    activeDeviceId: null,
    activeTripId: null, // No active trip initially
    speed: ReplaySpeed.NORMAL, // Default 1x speed
    isPlaying: {}, // No devices playing initially
};

export default (state = initialState, action: AnyAction): IReplayPointState => {
    switch (action.type) {
        case SET_REPLAY_POINT:
            return {
                ...state,
                point: action.payload?.point || action.payload,
            };

        case CLEAR_REPLAY_POINT:
            return {
                ...state,
                point: null,
            };

        case SET_ACTIVE_DEVICE_ID:
            return {
                ...state,
                activeDeviceId: action.payload?.deviceId || null,
            };

        case SET_REPLAY_SPEED:
            return {
                ...state,
                speed: action.payload?.speed || ReplaySpeed.NORMAL,
            };

        case SET_REPLAY_PLAYING:
            return {
                ...state,
                isPlaying: {
                    ...state.isPlaying,
                    [action.payload?.deviceId]: action.payload?.isPlaying || false,
                },
            };

        case SET_ACTIVE_TRIP_ID:
            return {
                ...state,
                activeTripId: action.payload?.tripId || null,
            };

        default:
            return state;
    }
};